const SEARCH_HISTORY_LIMIT = 5;

/** 四个 CRM 列表页的关键词搜索历史存储键。 */
export const SEARCH_HISTORY_KEYS = {
  contactKeyword: "fm.searchHistory.crm_contact_workbench.keyword",
  contactNlQuery: "fm.searchHistory.crm_contact_workbench.nlQuery",
  opportunityKeyword: "fm.searchHistory.crm_opportunity_workbench.keyword",
  opportunityCustomizationKeyword: "fm.searchHistory.crm_opportunity_workbench.customizationKeyword",
  opportunityCustomerKeyword: "fm.searchHistory.crm_opportunity_workbench.customerKeyword",
  customizationKeyword: "fm.searchHistory.customization_project_list.keyword",
  customizationOrganizationName: "fm.searchHistory.customization_project_list.organizationName",
  customizationDestination: "fm.searchHistory.customization_project_list.destination",
  customerRegionSchoolText: "fm.searchHistory.crm_customer_workbench.regionSchoolText",
  customerName: "fm.searchHistory.crm_customer_workbench.customerName",
  customerNlQuery: "fm.searchHistory.crm_customer_workbench.nlQuery",
} as const;

/** 读取最近搜索记录；无记录时返回空数组。 */
export function readSearchHistory(storageKey: string): string[] {
  if (typeof window === "undefined") {
    return [];
  }
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) {
      return [];
    }
    return normalizeHistoryEntries(parsed);
  } catch {
    return [];
  }
}

/**
 * 写入一条搜索记录：去空白、去重置顶，最多保留 5 条。
 * 空字符串不写入。
 */
export function rememberSearchHistory(storageKey: string, value: string): string[] {
  const normalized = value.trim();
  if (!normalized) {
    return readSearchHistory(storageKey);
  }
  const next = [
    normalized,
    ...readSearchHistory(storageKey).filter((item) => item !== normalized),
  ].slice(0, SEARCH_HISTORY_LIMIT);
  return writeSearchHistory(storageKey, next);
}

/** 删除单条搜索记录。 */
export function removeSearchHistory(storageKey: string, value: string): string[] {
  const normalized = value.trim();
  const next = readSearchHistory(storageKey).filter((item) => item !== normalized);
  return writeSearchHistory(storageKey, next);
}

/** 清空指定键的全部搜索记录。 */
export function clearSearchHistory(storageKey: string): string[] {
  return writeSearchHistory(storageKey, []);
}

/** 将规范化后的搜索历史写入 localStorage。 */
function writeSearchHistory(storageKey: string, next: string[]): string[] {
  if (typeof window === "undefined") {
    return next;
  }
  try {
    if (next.length === 0) {
      window.localStorage.removeItem(storageKey);
    } else {
      window.localStorage.setItem(storageKey, JSON.stringify(next));
    }
  } catch {
    // 隐私模式等写入失败时仍返回内存结果，便于当前会话下拉展示。
  }
  return next;
}

/** 清洗历史条目：去空白、去重并截断到上限。 */
function normalizeHistoryEntries(entries: unknown[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const entry of entries) {
    if (typeof entry !== "string") {
      continue;
    }
    const normalized = entry.trim();
    if (!normalized || seen.has(normalized)) {
      continue;
    }
    seen.add(normalized);
    result.push(normalized);
    if (result.length >= SEARCH_HISTORY_LIMIT) {
      break;
    }
  }
  return result;
}
